const mutations = {
  setToken: (state, data) => {
    state.token = data;
  },
  sendToken: (state, data) => {
    state.sendToken = data;
  },
  clearToken: state => {
    state.token = null;
  },
  setclientUid: (state, data) => {
    state.clientUid = data;
  },
  setLoading: (state, data) => {
    state.loading = data;
  }
};
export default mutations;
